export default __webpack_public_path__ + "static/media/logo-color.4a69a801.png";